import { EKIDEN_API_URL } from "@constants";

/** `denied` only when API returns 2xx body with `"whitelisted": false`. Anything else → `allowed`. */
export type WhitelistDecision = "allowed" | "denied";

type WhitelistCheckResponse = {
  root_address?: string;
  whitelisted?: boolean;
};

/**
 * GET /authorize/whitelist/check?root_address=…
 */
export const fetchWhitelistStatus = async (rootAddress: string): Promise<WhitelistDecision> => {
  if (!EKIDEN_API_URL) return "allowed";
  try {
    const base = EKIDEN_API_URL.replace(/\/$/, "");
    const url = new URL(`${base}/authorize/whitelist/check`);
    url.searchParams.set("root_address", rootAddress);

    const res = await fetch(url.toString());
    if (!res.ok) return "allowed";

    const json: unknown = await res.json().catch(() => null);
    if (!json || typeof json !== "object") return "allowed";

    const { whitelisted } = json as WhitelistCheckResponse;
    return whitelisted === false ? "denied" : "allowed";
  } catch {
    return "allowed";
  }
};
